import user from './user.png'
import fondo_cadena from './fondo_login_izquierdo_sin_icono2.jpg'


export default {
    "user": user,
    "fondo_cadena": fondo_cadena
}